import React from 'react'
import { usePaletteTheme } from '../../context/paletteTheme'
import styles from './Button.module.scss'


const ElevationButton = React.forwardRef(({onClick, elevation = 5, active = false, disabled = false, children}, ref) => {
    const { theme } = usePaletteTheme()
    const elevationNumber = active ? 6 : elevation

    return (
        <button ref={ref}
        disabled={disabled}
        onClick={onClick}
        className={styles['elevation-button']}
        style={theme.components.MuiPaper.styleOverrides['elevation'+elevationNumber]}
        >
            {children}
        </button>
    )
})

export default ElevationButton